import React from 'react';

export default function AuthView({ authMode, setAuthMode, authForm, setAuthForm, handleAuth }) {
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{authMode === 'login' ? 'Välkommen tillbaka' : 'Skapa konto'}</h2>
        <form className="auth-form" onSubmit={handleAuth}>
          <div className="auth-input-group">
            <label>Användarnamn</label>
            <input className="auth-input" type="text" value={authForm.username} onChange={e => setAuthForm({...authForm, username: e.target.value})} required />
          </div>
          <div className="auth-input-group">
            <label>Lösenord</label>
            <input className="auth-input" type="password" value={authForm.password} onChange={e => setAuthForm({...authForm, password: e.target.value})} required />
          </div>
          <button type="submit" className="auth-btn">{authMode === 'login' ? 'Logga in' : 'Registrera'}</button>
        </form>
        <div className="auth-switch">
          {authMode === 'login' ? 'Saknar konto?' : 'Redan medlem?'}
          <span onClick={() => setAuthMode(authMode === 'login' ? 'register' : 'login')}>
            {authMode === 'login' ? ' Skapa ett' : ' Logga in'}
          </span>
        </div>
      </div>
    </div>
  );
}
